// WebPOS Thai translations. Only customer-relevant keys; other keys fall back
// to English via i18next's `fallbackLng`.
export const webposTh = {
  'webpos.setup.registerNotAllowed': 'อุปกรณ์ใหม่ต้องตั้งค่าโดยผู้ดูแลระบบหรือผู้จัดการ (สิทธิ์การจัดการอุปกรณ์) เท่านั้น กรุณาเข้าสู่ระบบ BIS ERP บนอุปกรณ์นี้ด้วยบัญชีดังกล่าว',
  'webpos.common.cancel': 'ยกเลิก',
  'webpos.common.previous': 'ย้อนกลับ',
  'webpos.common.next': 'ถัดไป',
  'webpos.common.saving': 'กำลังบันทึก...',
  'webpos.common.loading': 'กำลังโหลดลูกค้า...',
  'webpos.common.reload': 'โหลดใหม่',
  'webpos.common.edit': 'แก้ไข',
  'webpos.common.close': 'ปิด',
  'webpos.common.save': 'บันทึก',
  'webpos.common.delete': 'ลบ',
  'webpos.common.or': 'หรือ',

  'webpos.customers.title': 'ลูกค้า',
  'webpos.customers.subtitle': 'จัดการข้อมูลลูกค้า — ซิงค์กับแอปขายหน้าร้านและศูนย์ลูกค้า',
  'webpos.customers.add': 'เพิ่มลูกค้า',
  'webpos.customers.searchPlaceholder': 'ค้นหาด้วยชื่อ บริษัท รหัสลูกค้า อีเมลหรือเบอร์โทร',
  'webpos.customers.statTotal': 'ทั้งหมด',
  'webpos.customers.statActive': 'ใช้งานอยู่',
  'webpos.customers.statInactive': 'ไม่ใช้งาน',
  'webpos.customers.colNumber': 'รหัส',
  'webpos.customers.colName': 'ชื่อ',
  'webpos.customers.colContact': 'ติดต่อ',
  'webpos.customers.colAddress': 'ที่อยู่',
  'webpos.customers.colDiscount': 'ส่วนลด',
  'webpos.customers.colStatus': 'สถานะ',
  'webpos.customers.active': 'ใช้งานอยู่',
  'webpos.customers.inactive': 'ไม่ใช้งาน',
  'webpos.customers.unnamed': '(ไม่มีชื่อ)',
  'webpos.customers.pageInfo': 'หน้า {{page}} จาก {{pages}} · ลูกค้า {{total}} ราย',
  'webpos.customers.emptyState': 'ยังไม่มีลูกค้า',
  'webpos.customers.noResultsSearch': 'ไม่พบลูกค้าที่ตรงกับการค้นหา',
  'webpos.customers.loadFailed': 'โหลดไม่สำเร็จ',
  'webpos.customers.saveFailed': 'บันทึกไม่สำเร็จ',
  'webpos.customers.deleteFailed': 'ลบไม่สำเร็จ',
  'webpos.customers.created': 'สร้างลูกค้าแล้ว',
  'webpos.customers.updated': 'บันทึกลูกค้าแล้ว',
  'webpos.customers.deleted': 'ปิดใช้งานลูกค้าแล้ว',
  'webpos.customers.createTitle': 'ลูกค้าใหม่',
  'webpos.customers.editTitle': 'แก้ไขลูกค้า',
  'webpos.customers.createBtn': 'สร้าง',
  'webpos.customers.deleteConfirmTitle': 'ปิดใช้งานลูกค้า?',
  'webpos.customers.deleteConfirmMessage': 'ลูกค้าจะถูกตั้งเป็น "ไม่ใช้งาน" ใบแจ้งหนี้และใบเสร็จที่มีอยู่จะไม่ได้รับผลกระทบ',
  'webpos.customers.secBasics': 'ข้อมูลพื้นฐาน',
  'webpos.customers.secContact': 'ข้อมูลติดต่อ',
  'webpos.customers.secAddress': 'ที่อยู่สำหรับใบเสร็จ',
  'webpos.customers.secConditions': 'เงื่อนไข',
  'webpos.customers.secNotes': 'บันทึกและสถานะ',
  'webpos.customers.fCustomerNumber': 'รหัสลูกค้า',
  'webpos.customers.fCustomerNumberHint': 'เว้นว่าง = อัตโนมัติ',
  'webpos.customers.fCompanyName': 'บริษัท',
  'webpos.customers.fFirstName': 'ชื่อ',
  'webpos.customers.fLastName': 'นามสกุล',
  'webpos.customers.fEmail': 'อีเมล',
  'webpos.customers.fPhone': 'โทรศัพท์',
  'webpos.customers.fMobile': 'มือถือ',
  'webpos.customers.fVatId': 'เลขผู้เสียภาษี',
  'webpos.customers.fStreet': 'ถนน',
  'webpos.customers.fHouseNumber': 'บ้านเลขที่',
  'webpos.customers.fPostalCode': 'รหัสไปรษณีย์',
  'webpos.customers.fCity': 'เมือง',
  'webpos.customers.fCountry': 'ประเทศ',
  'webpos.customers.fDiscount': 'ส่วนลด (%)',
  'webpos.customers.fPaymentTerms': 'เงื่อนไขการชำระ (วัน)',
  'webpos.customers.fNotes': 'บันทึกภายใน',
  'webpos.customers.fActive': 'ลูกค้ากำลังใช้งาน',

  // ติดตั้งเป็นแอป / เต็มจอ
  'webpos.install.title': 'เปิด POS แบบเต็มจอ',
  'webpos.install.subtitle': 'ไม่มีแถบเบราว์เซอร์ – เป็นไอคอนบนหน้าจอหลัก เหมือนแอป',
  'webpos.install.benefit1': 'เต็มจอ ไม่มีแถบที่อยู่และเมนู',
  'webpos.install.benefit2': 'ไอคอนแคชเชียร์ของตัวเองบนหน้าจอหลัก',
  'webpos.install.benefit3': 'เปิดเข้าสู่โหมดเต็มจอทันที',
  'webpos.install.button': 'เพิ่มไปยังหน้าจอโฮม',
  'webpos.install.later': 'ภายหลัง',
  'webpos.install.dontShowAgain': 'ไม่ต้องแสดงอีก',
  'webpos.install.iosTitle': 'เต็มจอใน 2 ขั้นตอน',
  'webpos.install.iosStep1': 'แตะไอคอนแชร์ด้านล่าง',
  'webpos.install.iosStep2': 'เลือก "เพิ่มไปยังหน้าจอโฮม"',
  'webpos.install.iosHint': 'จากนั้นเปิดแคชเชียร์ผ่านไอคอนใหม่ – จะทำงานเต็มจอโดยไม่มีแถบเบราว์เซอร์',
  'webpos.install.menuLabel': 'เปิดแบบเต็มจอ',
  'webpos.install.iosOtherTitle': 'ใช้ Safari เพื่อโหมดเต็มจอ',
  'webpos.install.iosOtherHint': 'เบราว์เซอร์นี้ไม่สามารถตั้งค่าโหมดเต็มจอบน iPhone/iPad ได้ กรุณาเปิด pos.bispicy.com ใน Safari แล้วเลือก "แชร์ → เพิ่มไปยังหน้าจอโฮม"',
  'webpos.install.androidTitle': 'เต็มจอใน 2 ขั้นตอน',
  'webpos.install.androidStep1': 'เปิดเมนูเบราว์เซอร์ (⋮)',
  'webpos.install.androidStep2': 'เลือก "เพิ่มไปยังหน้าจอโฮม"',
  'webpos.install.androidHint': 'จากนั้นเปิดแคชเชียร์ผ่านไอคอนใหม่ – เต็มจอโดยไม่มีแถบเบราว์เซอร์',
  'webpos.install.fullscreenNow': 'เปิดแบบเต็มจอตอนนี้แทน',

  // เมนูนำทาง (☰) — ป้ายกำกับตรงกับแอปแคชเชียร์
  'webpos.nav.dashboard': 'แดชบอร์ด',
  'webpos.nav.sales': 'การขาย',
  'webpos.nav.repairOrders': 'ใบสั่งซ่อม',
  'webpos.nav.tablePlan': 'แผนผังโต๊ะ',
  'webpos.nav.salesHistory': 'ประวัติการขาย',
  'webpos.nav.products': 'สินค้า',
  'webpos.nav.customers': 'ลูกค้า',
  'webpos.nav.appointments': 'การนัดหมาย',
  'webpos.nav.reports': 'รายงาน',
  'webpos.nav.settings': 'การตั้งค่า',
  'webpos.drawer.logout': 'ออกจากระบบ',
  'webpos.drawer.language': 'ภาษา',
  'webpos.drawer.fullscreen': 'เปิดแบบเต็มจอ',

  // แดชบอร์ด / ภาพรวม
  'webpos.dashboard.title': 'แดชบอร์ด',
  'webpos.dashboard.todayRevenue': 'ยอดขายวันนี้',
  'webpos.dashboard.todaySales': 'ใบเสร็จวันนี้',
  'webpos.dashboard.products': 'สินค้า',
  'webpos.dashboard.customers': 'ลูกค้า',
  'webpos.dashboard.lowStock': 'สินค้าหมด',

  // V-0642: การแจ้งเครื่องบันทึกเงินสด (§ 146a วรรค 4 AO) ในหน้า TSE — ผู้ประกอบการแจ้งเอง
  'webpos.tse.kassenmeldung_titel': 'การแจ้งเครื่องบันทึกเงินสด',
  'webpos.tse.kassenmeldung_text': 'คุณต้องแจ้งตาม § 146a วรรค 4 AO ด้วยตนเองผ่าน Mein ELSTER หรือผ่านที่ปรึกษาภาษีของคุณ ข้อมูลที่จำเป็น (เช่น หมายเลขซีเรียลของ TSE รุ่นและรหัสย่อของเครื่อง) อยู่ในศูนย์ลูกค้าที่หัวข้อ “เอกสารขั้นตอนการปฏิบัติงาน” หากมีคำถาม ฝ่ายสนับสนุนยินดีช่วยเหลือ',

  // V-0607: รับคืนภาชนะมัดจำ
  'webpos.pfand.title': 'รับคืนภาชนะมัดจำ',
  'webpos.pfand.payout': 'จ่ายคืน',
  'webpos.pfand.pieces': '{{count}} ชิ้น',
  'webpos.pfand.confirm': 'จ่ายเงินมัดจำคืน',
  'webpos.pfand.empty': 'ยังไม่ได้ตั้งค่าประเภทเงินมัดจำสำหรับกิจการนี้',
  'webpos.pfand.addFailed': 'ไม่สามารถเพิ่มการคืนเงินมัดจำได้',
  'webpos.pfand.toPay': 'ยอดที่ต้องจ่ายคืน',
  'webpos.pfand.payoutCash': 'จ่ายเงินมัดจำคืนเป็นเงินสด',
  'webpos.pfand.payoutHint': 'ใบเสร็จเป็นยอดติดลบ: จ่ายเงินคืนเป็นเงินสดจากลิ้นชักเก็บเงิน',
  'webpos.pfand.payoutFailed': 'การจ่ายเงินคืนล้มเหลว',

  // V-0582: การพิมพ์ใบเสร็จผ่าน BISPrint
  'webpos.print.noReceiptPrinter': 'ไม่มีเครื่องพิมพ์ใบเสร็จที่ใช้งานได้ — ไม่ได้พิมพ์ใบเสร็จ',
  'webpos.print.noKitchenPrinter': 'เครื่องพิมพ์ครัวที่กำหนดไว้ไม่พร้อมใช้งาน — ไม่ได้พิมพ์ใบสั่งครัว รายการถูกส่งไปที่ครัวแล้ว',
  'webpos.print.receiptFailed': 'ไม่สามารถส่งใบเสร็จไปยังเครื่องพิมพ์ได้',
  'webpos.print.kitchenFailed': 'ไม่สามารถส่งใบสั่งครัวไปยังเครื่องพิมพ์ได้ รายการถูกส่งไปที่ครัวแล้ว',
  'webpos.print.sent': 'ส่งใบเสร็จไปยังเครื่องพิมพ์แล้ว',
  'webpos.print.settings.saveFailed': 'ไม่สามารถบันทึกการตั้งค่าการพิมพ์ได้',
  'webpos.print.settings.receiptPrinterHint': 'หากไม่เลือก ใบเสร็จจะพิมพ์ที่เครื่องพิมพ์ใบเสร็จที่กำหนดไว้ใน BIS ERP หรือที่เครื่องพิมพ์เริ่มต้นของเครื่อง BISPrint',
  'webpos.print.settings.autoPrint': 'พิมพ์ใบเสร็จอัตโนมัติหลังการขาย',
  'webpos.print.settings.autoPrintHint': 'ใบเสร็จจะถูกพิมพ์ผ่าน BISPrint หลังการขายทุกครั้ง การพิมพ์จากประวัติการขายใช้ได้โดยไม่ขึ้นกับตัวเลือกนี้',
  'webpos.print.settings.autoPrintOff': 'การพิมพ์ใบเสร็จอัตโนมัติยังปิดอยู่สำหรับเครื่องนี้ เปิดใช้งานแล้วบันทึกหากต้องการพิมพ์ทุกการขายอัตโนมัติ',
  'webpos.print.settings.kitchenPrinter': 'เครื่องพิมพ์ครัว',
  'webpos.print.settings.autoPrintNeedsBisprint': 'ใช้ได้เฉพาะโหมดการพิมพ์ “BISPrint Cloud” หากพิมพ์ผ่านเบราว์เซอร์ (รวมถึงกรณีที่ไม่เคยเลือก) จะไม่พิมพ์ใบเสร็จอัตโนมัติ',
  'webpos.print.settings.kitchenPrinterHint': 'ใบสั่งครัวจะถูกพิมพ์เมื่อกด “ส่งไปครัว” ก็ต่อเมื่อมีการกำหนดเครื่องพิมพ์ที่นี่หรือใน BIS ERP (การตั้งค่า → การพิมพ์ ประเภทเอกสาร “ใบสั่งครัว”)',
  'webpos.print.settings.kitchenPrinterDefault': 'ไม่มี (เว้นแต่กำหนดส่วนกลางใน BIS ERP)',
  'webpos.print.settings.offline': 'ออฟไลน์',
};

